import { Brand } from './Brand'

type Reason = 'ios' | 'safari' | 'firefox' | 'no-speech' | 'other'

const MESSAGES: Record<Reason, string> = {
  ios: 'The 24-game needs Chrome on a desktop or an Android phone. iPhones and iPads can’t do live voice transcription in the browser yet.',
  safari: 'Safari can’t run the live voice transcription this uses. Please open this page in Chrome on a desktop or Android phone.',
  firefox: 'Firefox can’t run the live voice transcription this uses. Please open this page in Chrome on a desktop or Android phone.',
  'no-speech': 'This browser doesn’t support the Web Speech API we use for live transcription. Please open this page in Chrome on a desktop or Android phone.',
  other: 'Please open this page in Chrome on a desktop or Android phone to play the 24-game.',
}

export const BrowserGate = ({ reason }: { reason: Reason }) => (
  <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
    <Brand />
    <div className="mt-8 max-w-md">
      <h1 className="text-lg font-semibold text-gray-800">Use Chrome desktop or Android</h1>
      <p className="mt-3 text-gray-600 leading-relaxed">{MESSAGES[reason]}</p>
    </div>
  </div>
)
